import {
  EERROR_BUTTON_EVENT,
  EERROR_ICON,
  EERROR_PAGE_TYPES,
  IErrorComponentData,
} from '@app/core/models/error.model';

export const ERROR_CONSTANTS = {
  ERRORS: {
    MESSAGE_BACKEND: {
      DEFAULT: 'default',
      EXIST_PHONE_NUMBER: 'Customer exists with another phone number.',
      EMAIL_EXIST: 'The email is already in use.',
      CODE_NO_EXISTS: 'The code did not match.',
      CORS: 'CORS',
      DEBIT_CARD: 'debit',
      CUSTOMER_EXISTS: 'Customer exists.',
      ERROR_500: 'Internal server error, please retry later',
      ERROR_1003_TOKEN_ID_DOESNT_EXIST: `1003:token id does not exist`,
      ERROR_1550_INVALID_CODE: `1550:invalid code authorization`,
      ERROR_1550_INVALID_CARD: `1550:invalid card, declined by the bank`,
      ERROR_1550_CARD_BLOCKED: `1550:card blocked, declined by the bank`,
      ERROR_1550_MERCHANT_ID_INVALID: `1550:merchant indentification invalid`,
      ERROR_2011_TYPE_NOT_SUPPORTED: `2011:card product type not supported`,
      ERROR_3001_CARD_DECLINED_BY_BANK: `3001:the card was declined by the bank`,
      ERROR_3002_CARD_EXPIRED: `3002:the card has expired`,
      ERROR_3003_INSUFFICIENT_FUNDS: `3003:the card doesn't have sufficient funds`,
    },
    MESSAGE_FRONTEND: {
      DEFAULT: 'Ha ocurrido un error, intente nuevamente',
      EXIST_PHONE_NUMBER: 'La transacción se encuentra creada con un número de teléfono diferente.',
      CODE_NO_EXISTS: 'El código ingresado es incorrecto',
      CORS: 'Error de permisos CORS',
      EMAIL_EXIST: 'El email ya se encuentra asociado a otra cuenta',
      DEBIT_CARD: 'La tarjeta debe ser crédito',
      CUSTOMER_EXISTS: '¡Revisa tus datos!<br />Los datos que ingresaste son incorrectos.',
      ERROR_1003_TOKEN_ID_DOESNT_EXIST: `1003:token id does not exist`,
      ERROR_1550_INVALID_CODE: `1550:invalid code authorization`,
      ERROR_1550_INVALID_CARD: `1550:invalid card, declined by the bank`,
      ERROR_1550_CARD_BLOCKED: `1550:card blocked, declined by the bank`,
      ERROR_1550_MERCHANT_ID_INVALID: `1550:merchant indentification invalid`,
      ERROR_2011_TYPE_NOT_SUPPORTED: `2011:card product type not supported`,
      ERROR_3001_CARD_DECLINED_BY_BANK: `3001:the card was declined by the bank`,
      ERROR_3002_CARD_EXPIRED: `3002:the card has expired`,
      ERROR_3003_INSUFFICIENT_FUNDS: `3003:the card doesn't have sufficient funds`,
    },
  },
};

export const ERROR_COMPONENT_CONSTANTS: { [key: string]: IErrorComponentData } = {
  [EERROR_PAGE_TYPES.ERROR_01]: {
    icon: EERROR_ICON.WARNING,
    title: 'Lo sentimos',
    description:
      'Encontramos un error en el proceso que nos impide seguir. Por favor, inténtalo nuevamente.',
    buttons: [
      {
        buttonText: 'Volver al comercio',
        buttonEvent: EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_02]: {
    icon: EERROR_ICON.TIME_OUT,
    title: 'Fuera de tiempo',
    description:
      'Parece que la confirmación de tu compra tomó más tiempo de lo esperado. Por favor, inténtalo nuevamente más tarde.',
    buttons: [
      {
        buttonText: 'Volver al comercio',
        buttonEvent: EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_03]: {
    icon: EERROR_ICON.CAUTION,
    title: 'Pago inconcluso',
    description:
      'Se presentó un problema al realizar el pago. Por favor, inténtalo de nuevo ahora o prueba a hacerlo más tarde.',
    buttons: [
      {
        buttonText: 'Reintentar',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_04]: {
    icon: EERROR_ICON.CAUTION,
    title: 'Pago inconcluso',
    description:
      'Se presentó un problema al realizar el pago. Por favor, inténtalo nuevamente revisando los datos ingresados o utilizando otra tarjeta de crédito.',
    buttons: [
      {
        buttonText: 'Reintentar',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_05]: {
    icon: EERROR_ICON.TIME_OUT,
    title: '¡No te vayas!',
    description: 'Si sales del proceso, tu solicitud actual de aplazamiento será cancelada.',
    buttons: [
      {
        buttonText: 'Salir del proceso',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
      {
        buttonText: 'Continuar con la solicitud',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_06]: {
    icon: EERROR_ICON.CAUTION,
    title: 'Sin conexión a internet',
    description:
      'Parece que tu dispositivo no tiene conexión a internet. Intentaremos restablecerla; sin embargo, si el problema persiste te recomendamos contactar a tu operador.',
    buttons: [
      {
        buttonText: 'Entendido',
        buttonEvent: EERROR_BUTTON_EVENT.CONTINUE,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_07]: {
    icon: EERROR_ICON.WARNING,
    title: 'Sobrepasaste el límite de ingresos fallidos al perfil',
    description:
      'Acabamos de bloquear tu usuario, pues sobrepasaste el límite de intentos fallidos para ingresar a tu perfil. Si deseas desbloquearlo, gestiona tu contraseña.',
    buttons: [
      {
        buttonText: 'Gestionar contraseña',
        buttonEvent: EERROR_BUTTON_EVENT.SETUP_PASSWORD,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_08]: {
    icon: EERROR_ICON.WARNING,
    title: 'Datos incorrectos',
    description:
      'Los datos que ingresaste son incorrectos, te recomendamos revisarlos. Además, ten en cuenta que luego de 3 intentos fallidos bloqueareamos tu usuario por seguridad.',
    buttons: [
      {
        buttonText: 'Entendido',
        buttonEvent: EERROR_BUTTON_EVENT.CONTINUE,
      },
      {
        buttonText: 'Recuperar o crear contraseña',
        buttonEvent: EERROR_BUTTON_EVENT.SETUP_PASSWORD,
      },
    ],
  },
  // Expired card error in first purchase
  [EERROR_PAGE_TYPES.ERROR_09]: {
    icon: EERROR_ICON.CAUTION,
    title: 'Tarjeta vencida',
    description:
      'Tu tarjeta *{dummyCreditCardNumber} superó la fecha de caducidad. Ingresa otra tarjeta de crédito e inténtalo nuevamente.',
    buttons: [
      {
        buttonText: 'Reintentar',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_10]: {
    icon: EERROR_ICON.WARNING,
    title: '¡Será en otra ocasión!',
    description:
      'Basándonos en los datos que nos facilitaste, no podemos ofrecerte la posibilidad de aplazar la compra con nosotros.',
    buttons: [
      {
        buttonText: 'Volver al comercio',
        buttonEvent: EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_11]: {
    icon: EERROR_ICON.WARNING,
    title: '¡Será en otra ocasión!',
    description:
      'Basándonos en los datos que nos facilitaste, no podemos ofrecerte la posibilidad de aplazar la compra con nosotros. <br><br> Te recomendamos contactar a tu entidad bancaria.',
    buttons: [
      {
        buttonText: 'Volver al comercio',
        buttonEvent: EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_12]: {
    icon: EERROR_ICON.ERROR,
    title: 'Pago inconcluso',
    description:
      'Se presentó un problema al realizar el pago. Por favor, revisa los datos ingresados e inténtalo nuevamente.',
    buttons: [
      {
        buttonText: 'Volver al comercio',
        buttonEvent: EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_13]: {
    icon: EERROR_ICON.WARNING,
    title: 'Se presentó un problema al realizar el pago',
    description: 'Por favor, revisa el codigo CVV que ingresaste.',
    buttons: [
      {
        buttonText: 'Reintentar',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_14]: {
    icon: EERROR_ICON.WARNING,
    title: 'Se presentó un problema al realizar el pago',
    description: `Por favor, inténtalo nuevamente:<br /><br /><br />
    <div class="error-bullet"><img src="/assets/icons/blue-bullet.svg" />Revisa los datos ingresados.</div><br />
    <div class="error-bullet"><img src="/assets/icons/blue-bullet.svg" />Activa tu tarjeta para compras por internet.</div><br />
    <div class="error-bullet"><img src="/assets/icons/blue-bullet.svg" />O, utiliza otra tarjeta de crédito.</div>`,
    buttons: [
      {
        buttonText: 'Reintentar',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_15]: {
    icon: EERROR_ICON.WARNING,
    title: 'Se presentó un problema al realizar el pago',
    description: 'Por favor, inténtalo nuevamente utilizando otra tarjeta de crédito.',
    buttons: [
      {
        buttonText: 'Reintentar',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_16]: {
    icon: EERROR_ICON.WARNING,
    title: 'Se presentó un problema al realizar el pago',
    description: 'Por favor, revisa los fondos de tu tarjeta o usa otra tarjeta de crédito.',
    buttons: [
      {
        buttonText: 'Reintentar',
        buttonEvent: EERROR_BUTTON_EVENT.TRY_AGAIN,
      },
    ],
  },
  // Expired card error in second purchase
  [EERROR_PAGE_TYPES.ERROR_17]: {
    icon: EERROR_ICON.WARNING,
    title: 'Tarjeta vencida',
    description:
      'Tu tarjeta *{dummyCreditCardNumber} superó la fecha de caducidad. Cambia tu medio de pago ingresando a tu perfil Powerpay. Luego, podrás solicitar nuevamente el aplazamiento. ',
    buttons: [
      {
        buttonText: 'Ir a mi perfil Powerpay',
        buttonEvent: EERROR_BUTTON_EVENT.GO_TO_MY_PROFILE,
      },
    ],
  },
  [EERROR_PAGE_TYPES.ERROR_18]: {
    icon: EERROR_ICON.CAUTION,
    title: 'Lo sentimos',
    description:
      'Encontramos un error en el proceso que nos impide seguir. Por favor, inténtalo nuevamente.',
    buttons: [
      {
        buttonText: 'Volver al comercio',
        buttonEvent: EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE,
      },
    ],
  },
  // AGGREGATOR CAPACITY ERROR
  [EERROR_PAGE_TYPES.ERROR_19]: {
    icon: EERROR_ICON.WARNING,
    title: '¡Será en otra ocasión!',
    description: 'Alcanzaste tu límite máximo de compras con Powerpay en este comercio.',
    buttons: [
      {
        buttonText: 'Ver otros comercios con Powerpay.',
        buttonEvent: EERROR_BUTTON_EVENT.GO_TO_LANDING,
      },
    ],
  },
  //TOKEN ID DOESNT EXIST ERROR
  [EERROR_PAGE_TYPES.ERROR_20]: {
    icon: EERROR_ICON.WARNING,
    title: 'Lo sentimos',
    description:
      'Encontramos un error en el proceso que nos impide seguir. Por favor, inténtalo nuevamente.',
    buttons: [
      {
        buttonText: 'Volver al comercio',
        buttonEvent: EERROR_BUTTON_EVENT.RETURN_TO_ECCOMERCE,
      },
    ],
  },
  // 3001 error in second purchase
  [EERROR_PAGE_TYPES.ERROR_21]: {
    icon: EERROR_ICON.WARNING,
    title: 'Se presentó un problema al realizar el pago',
    description: `Por favor, inténtalo nuevamente:<br /><br /><br />
    <div class="error-bullet"><img src="/assets/icons/blue-bullet.svg" />Revisa los datos ingresados.</div><br />
    <div class="error-bullet"><img src="/assets/icons/blue-bullet.svg" />Activa tu tarjeta para compras por internet.</div><br />
    <div class="error-bullet"><img src="/assets/icons/blue-bullet.svg" />O, utiliza otra tarjeta de crédito.</div>`,
    buttons: [
      {
        buttonText: 'Ir a mi perfil Powerpay',
        buttonEvent: EERROR_BUTTON_EVENT.GO_TO_MY_PROFILE,
      },
    ],
  },
};

export const OPENPAY_ERRORS = {
  [EERROR_PAGE_TYPES.ERROR_01]: [
    '1000',
    '1001',
    '1002',
    '1003',
    '1004',
    '1005',
    '1006',
    '1009',
    '1010',
    '1011',
    '1012',
    '1013',
    '1014',
    '1015',
    '1016',
    '1017',
    '1018',
    '1020',
    '1023',
    '1024',
    '1025',
    '2006',
    '3203',
    '3204',
    '3205',
    '4001',
    '4002',
    '6001',
    '6002',
    '6003',
  ],
  [EERROR_PAGE_TYPES.ERROR_02]: [],
  [EERROR_PAGE_TYPES.ERROR_03]: ['1007', '1008'],
  [EERROR_PAGE_TYPES.ERROR_04]: ['2004', '2007', '2008', '2009', '2010'],
  [EERROR_PAGE_TYPES.ERROR_05]: [],
  [EERROR_PAGE_TYPES.ERROR_06]: [],
  [EERROR_PAGE_TYPES.ERROR_07]: [],
  [EERROR_PAGE_TYPES.ERROR_08]: [],
  [EERROR_PAGE_TYPES.ERROR_09]: [
    '2005',
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_3002_CARD_EXPIRED,
    '3002',
  ],
  [EERROR_PAGE_TYPES.ERROR_10]: ['3004', '3005', '3006', '3009', '3010', '3012'],
  [EERROR_PAGE_TYPES.ERROR_11]: ['3011'],
  [EERROR_PAGE_TYPES.ERROR_12]: [],
  [EERROR_PAGE_TYPES.ERROR_13]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_1550_INVALID_CODE,
    '1550',
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_2011_TYPE_NOT_SUPPORTED,
    '2011',
  ],
  [EERROR_PAGE_TYPES.ERROR_14]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_3001_CARD_DECLINED_BY_BANK,
    '3001',
  ],
  [EERROR_PAGE_TYPES.ERROR_15]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_1550_INVALID_CARD,
    '1550',
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_1550_CARD_BLOCKED,
    '1550',
  ],
  [EERROR_PAGE_TYPES.ERROR_16]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_3003_INSUFFICIENT_FUNDS,
    '3003',
  ],
  [EERROR_PAGE_TYPES.ERROR_17]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_3002_CARD_EXPIRED,
    '3002',
  ],
  [EERROR_PAGE_TYPES.ERROR_18]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_1550_MERCHANT_ID_INVALID,
    '1550',
  ],
  [EERROR_PAGE_TYPES.ERROR_19]: [],
  [EERROR_PAGE_TYPES.ERROR_20]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_1003_TOKEN_ID_DOESNT_EXIST,
    '1003',
  ],
  [EERROR_PAGE_TYPES.ERROR_21]: [
    ERROR_CONSTANTS.ERRORS.MESSAGE_BACKEND.ERROR_3001_CARD_DECLINED_BY_BANK,
    '3001',
  ],
};
